import { z } from 'zod';

export const jobSchema = z.object({
  jobTitle: z
    .string()
    .min(1, 'Job title is required')
    .min(3, 'Job title must be at least 3 characters')
    .max(200, 'Job title must be less than 200 characters')
    .trim(),

  // Address fields
  addressLine1: z.string().optional().or(z.literal('')),
  addressLine2: z.string().optional().or(z.literal('')),
  landmark: z.string().optional().or(z.literal('')),
  city: z.string().optional().or(z.literal('')),
  state: z.string().optional().or(z.literal('')),
  pincode: z.string().optional().or(z.literal('')),
  country: z.string().optional().or(z.literal('')),

  currency: z.string().min(1, 'Currency is required'),

  compensation: z.string().optional().or(z.literal('')),

  description: z.string().optional().or(z.literal('')),

  requirement: z.string().optional().or(z.literal('')),

  applicationDeadline: z.string().min(1, 'Application deadline is required'),

  applicationDeadlineTime: z.string().optional().or(z.literal('')),

  applicationLink: z.union([
    z.string().url('Must be a valid URL'),
    z.literal(''),
  ]).optional(),

  visibility: z.enum(['Public', 'Private']),

  status: z.enum(['Active', 'Inactive', 'Closed']),
});

export const createJobSchema = jobSchema.extend({
  sellerId: z.string().min(1, 'Please select a seller'),
});

